/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const ProjectListHeader = ({
  userInfo,
  moduleAccess,
  reloadList,
  updateRankHandler = () => {},
  projectList = [],
  followingProjectCount = 0,
  totalTaskCount = 0,
  totalLogsCount = 0,
  jsonFilterQuery = [],
  selectedProjectIds = [],
  setShowDeleteOffcanvas = () => {},
}) => {
  const { t } = useTranslation(); //for translation
  const breadcrumbTxt = [{ title: t("Projects") }];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          {/* ------ bread crumb ----------- */}
          <BreadCrumb breadCrumbText={breadcrumbTxt} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <ul className="d-flex align-items-center gap-2 me-2">
            <li role="presentation">
              Projects :{" "}
              <span className="text-primary">{projectList.length}</span>
            </li>
            <li role="presentation">
              Following :{" "}
              <span className="text-primary">{followingProjectCount}</span>
            </li>

            <li role="presentation">
              Tasks : <span className="text-primary">{totalTaskCount}</span>
            </li>

            <li role="presentation">
              Logs : <span className="text-primary">{totalLogsCount}</span>
            </li>
          </ul>
          {/* -------------- refresh ----------------- */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedProjectIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>

              {userInfo.role.slug === "ADMIN" ||
              userInfo.role.slug === "SUPER_ADMIN" ||
              (moduleAccess.includes("MOD_PROJECT") &&
                moduleAccess.includes("MOD_CREATE_PROJECT")) ? (
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedProjectIds.length === 0
                        ? "disabled text-muted"
                        : ""
                    }`}
                    onClick={updateRankHandler}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      progress_activity
                    </span>
                    <span className="d-block">{t("Update Rank")}</span>
                  </Link>
                </li>
              ) : null}
              {userInfo.role.slug === "ADMIN" ||
              userInfo.role.slug === "SUPER_ADMIN" ||
              (moduleAccess.includes("MOD_PROJECT") &&
                moduleAccess.includes("MOD_CREATE_PROJECT")) ? (
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedProjectIds.length === 0
                        ? "disabled text-muted"
                        : ""
                    }`}
                    data-bs-toggle="modal"
                    data-bs-target="#addCompanyModal"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      apartment
                    </span>
                    <span className="d-block">{t("Assign Company")}</span>
                  </Link>
                </li>
              ) : null}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedProjectIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedProjectIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedProjectIds.length === 0
                      ? undefined
                      : "#addFollowers"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              {userInfo.role.slug === "ADMIN" ||
              userInfo.role.slug === "SUPER_ADMIN" ||
              (moduleAccess.includes("MOD_PROJECT") &&
                moduleAccess.includes("MOD_CREATE_PROJECT")) ? (
                <li>
                  <Link
                    to="#"
                    data-bs-toggle={
                      selectedProjectIds.length === 0 ? undefined : "offcanvas"
                    }
                    data-bs-target={
                      selectedProjectIds.length === 0
                        ? undefined
                        : "#offcanvasProjectDisable"
                    }
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedProjectIds.length === 0
                        ? "disabled text-muted"
                        : "text-danger"
                    }`}
                    onClick={() =>
                      setShowDeleteOffcanvas(
                        selectedProjectIds.length > 0 ? true : false,
                      )
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">{t("Delete")}</span>
                  </Link>
                </li>
              ) : null}
            </ul>
          </div>
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasProjectFilter"
            aria-controls="offcanvasProjectFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          (moduleAccess.includes("MOD_PROJECT") &&
            moduleAccess.includes("MOD_CREATE_PROJECT")) ? (
            <Link
              to="/admin/projectmanagement/details"
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            >
              <span className="material-symbols-outlined icon-md">add</span>
              <span className="d-block">{t("Add New")}</span>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProjectListHeader;
